import { Reviews } from '@mui/icons-material';
import { Stack, Text } from '@ltvco/refresh-lib/theme';
import {
  ModalContent,
  PrimaryPillButton,
  StyledIntroModal,
} from './components';
import { scrollToElement } from '@ltvco/refresh-lib/utils';
import {
  COMMUNITY_BUZZ_CTA_DESCRIPTION,
  COMMUNITY_BUZZ_GA4_EVENTS,
} from 'components/CommunityBuzz/constants';
import { useAppConfigContext } from '@ltvco/refresh-lib/ctx';

interface CommunityBuzzIntroModalProps {
  open: boolean;
  onClose: () => void;
  make: string;
  model: string;
  year: string;
  trim: string;
}

export const CommunityBuzzIntroModal = ({
  open,
  onClose,
  make,
  model,
  year,
  trim,
}: CommunityBuzzIntroModalProps) => {
  const { trackEventGA4 } = useAppConfigContext();
  const vehicleName = [year, make, model, trim].filter(Boolean).join(' ');

  const handlePrimaryActionClick = () => {
    onClose();
    scrollToElement('community-buzz-section');
    const { communityBuzzCtaModalCloseAction } = COMMUNITY_BUZZ_GA4_EVENTS;
    trackEventGA4({
      event_name: communityBuzzCtaModalCloseAction.name,
      type: communityBuzzCtaModalCloseAction.type,
    });
  };

  return (
    <StyledIntroModal open={open} onClose={onClose} hasCloseIcon>
      <ModalContent>
        <Reviews fontSize="large" color="secondary" />
        <Stack spacing={1} alignItems="center">
          <Text variant="h3">{COMMUNITY_BUZZ_CTA_DESCRIPTION.title}</Text>
          <Text variant="h4">{COMMUNITY_BUZZ_CTA_DESCRIPTION.subtitle}</Text>
          <Text variant="body1" maxWidth={560}>
            {COMMUNITY_BUZZ_CTA_DESCRIPTION.descriptionWithVehicleName(
              vehicleName,
            )}
          </Text>
        </Stack>
        <PrimaryPillButton
          variant="contained"
          onClick={handlePrimaryActionClick}
        >
          See the most talked about topics
        </PrimaryPillButton>
      </ModalContent>
    </StyledIntroModal>
  );
};
